const FINAL_REQUEST_STATUSES = new Set(["completed", "failed", "stopped", "cancelled"]);

export function isFreshChatSession(session, now = Date.now()) {
  const timestamp = session?.lastConversationAt;
  if (!timestamp) return false;
  const utc = /[zZ]|[+-]\d{2}:?\d{2}$/.test(timestamp) ? timestamp : `${timestamp}Z`;
  const age = now - Date.parse(utc);
  return Number.isFinite(age) && age < 60 * 60 * 1000;
}

function taskIdsFromValue(value) {
  const values = Array.isArray(value) ? value : value == null ? [] : [value];
  return values
    .map((item) => {
      if (typeof item === "string") return item;
      if (!item || typeof item !== "object") return "";
      return item.taskId || item.task_id || item.id || "";
    })
    .filter(Boolean);
}

export function collectPendingTaskIds(actions) {
  return (Array.isArray(actions) ? actions : []).flatMap((action) => {
    if (!action || action.success === false) return [];
    const taskId = action.taskId || action.task_id;
    return taskId ? [String(taskId)] : [];
  });
}

export function normalizeActiveTurnStatus(payload) {
  const value = payload && typeof payload === "object" ? payload : {};
  const pendingValue = value.pendingTasks ?? value.pending_tasks;
  const pendingKnown = pendingValue !== undefined;
  let pendingTaskIds = [];
  let pendingTaskCount = 0;

  if (Array.isArray(pendingValue)) {
    pendingTaskIds = taskIdsFromValue(pendingValue);
    pendingTaskCount = pendingValue.length;
  } else if (pendingValue && typeof pendingValue === "object") {
    pendingTaskIds = taskIdsFromValue(
      pendingValue.ids ?? pendingValue.taskIds ?? pendingValue.tasks
    );
    pendingTaskCount = Number(pendingValue.count ?? pendingTaskIds.length) || 0;
  } else if (typeof pendingValue === "number") {
    pendingTaskCount = Math.max(0, pendingValue);
  } else if (pendingValue === true) {
    pendingTaskCount = 1;
  }

  return {
    ...value,
    active: Boolean(value.active),
    requestId: value.requestId || value.activeRequestId || value.active_request_id || null,
    detached: Boolean(value.detached),
    pendingTasksKnown: pendingKnown,
    pendingTasks: pendingTaskCount > 0,
    pendingTaskCount,
    pendingTaskIds,
  };
}

export function normalizeChatConflict(errorBody, fallbackStatus) {
  const body = errorBody && typeof errorBody === "object" ? errorBody : {};
  const detail = body.detail;
  const structured = detail && typeof detail === "object" ? detail : {};
  const requestStatus = String(structured.status ?? body.status ?? "").toLowerCase();
  const requestId = structured.activeRequestId
    || structured.active_request_id
    || structured.requestId
    || body.activeRequestId
    || body.active_request_id
    || body.requestId
    || null;
  const message = typeof detail === "string"
    ? detail
    : structured.error || structured.message || body.error || body.message || fallbackStatus;

  return {
    message,
    requestId,
    status: requestStatus || null,
    duplicate: Boolean(structured.duplicate ?? body.duplicate),
    active: !FINAL_REQUEST_STATUSES.has(requestStatus),
  };
}

export function historyContainsTaskResult(messages, taskId) {
  const callbackRequestId = `cbk-${taskId}`;
  return (Array.isArray(messages) ? messages : []).some((message) => (
    message?.requestId === callbackRequestId
    || message?.metadata?.taskId === taskId
    || message?.metadata?.task_id === taskId
  ));
}

export function dedupeHistoryMessages(messages) {
  const seen = new Set();
  return (Array.isArray(messages) ? messages : []).filter((message) => {
    const key = message?.messageId
      ? `message:${message.messageId}`
      : [message?.role, message?.requestId, message?.timestamp, message?.content].join(":");
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}